import { useLazyQuery } from '@apollo/client/react';
import { useFormContext } from '@slal/ui/react-hook-form/core';
import { nanoid } from 'nanoid';
import { UploadLogo } from '~/graphql';
import { fetchVoid } from '~/utils';

type UploadLogoResponse = {
    uploadLogo: {
        url: string;
    };
};

export const usePersonaliseCardData = () => {
    const { control, watch, setValue, getValues } = useFormContext();
    const [welcomeNote, introductionNote, finalComment] = watch(['welcomeNote', 'introductionNote', 'finalComment']);
    const [fetchSignedUrl] = useLazyQuery<UploadLogoResponse>(UploadLogo);

    const handleImageUpload = async (imageDataURL: string | undefined) => {
        if (!imageDataURL) {
            console.error('No image data provided');
            return;
        }

        try {
            const logoImageId = nanoid();

            const { data } = await fetchSignedUrl({
                variables: { input: { filename: logoImageId } },
            });

            const signedUrl = data?.uploadLogo?.url;
            if (!signedUrl) {
                throw new Error('Failed to fetch signed URL');
            }

            const fileBlob = await fetch(imageDataURL).then(res => res.blob());
            await fetchVoid(signedUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': fileBlob.type,
                },
                body: fileBlob,
            });

            setValue('signedUrl', signedUrl);
            setValue('logoImageId', logoImageId);
        } catch (error) {
            console.error('Image upload failed:', error);
        }
    };

    return {
        control,
        watch,
        setValue,
        getValues,
        welcomeNote,
        introductionNote,
        finalComment,
        handleImageUpload,
    };
};
